/*
 * @FilePath: CesiumDraw.js
 * @Author: chenwei
 * @Date: 2022-02-24 09:46:29
 * @LastEditors: chenwei
 * @LastEditTime: 2022-08-10 16:55:49
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
const Cesium = window.Cesium
export default class Cesium_measure{
    constructor(viewer,drawGroup,areaGroup){
        this.viewer = viewer
        this.drawGroup = drawGroup
        this.areaGroup = areaGroup
    }
    BlueCover(array){
        this.areaGroup.entities.add({
            polygon: {
                hierarchy: {
                    positions: array,
                },
                material: Cesium.Color.RED.withAlpha(0.1),
                outlineColor: Cesium.Color.RED,
                outlineWidth: 2
            },
        });
    }
    addPoint(){
        return new Promise((resolve) =>{
            let that = this
            var handlerPointe = new Cesium.ScreenSpaceEventHandler(that.viewer.scene.canvas);
            var scene = that.viewer.scene
            var ellipsoid = scene.globe.ellipsoid
            let x
            let y
            handlerPointe.setInputAction(function (movement) {
                let click_position = that.viewer.scene.camera.pickEllipsoid(movement.position, ellipsoid);
                let carto_position = ellipsoid.cartesianToCartographic(click_position);
                y = Cesium.Math.toDegrees(carto_position.longitude);
                x = Cesium.Math.toDegrees(carto_position.latitude);
                that.DrawPoint(y,x)
                resolve([x,y])
                handlerPointe.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
        })
    }
    DrawPoint(x,y){
        this.drawGroup.entities.add({
            // fromDegrees（经度，纬度，高度，椭球，结果）从以度为单位的经度和纬度值返回Cartesian3位置
            position: Cesium.Cartesian3.fromDegrees(x, y, 10),
            point: {
              // 点的大小（像素）
              pixelSize: 5,
              // 点位颜色，fromCssColorString 可以直接使用CSS颜色
              color: Cesium.Color.fromCssColorString('#0066FF'),
              // 边框颜色
              outlineColor: Cesium.Color.fromCssColorString('#0066FF'),
              // 边框宽度(像素)
              outlineWidth: 2,
              // 是否显示
              show: true
            }
        });
    }
    
    getPointFromWindowPoint(point){
        if(this.viewer.scene.terrainProvider.constructor.name=="EllipsoidTerrainProvider") {
            return this.viewer.camera.pickEllipsoid(point,this.viewer.scene.globe.ellipsoid);
        } else {
            var ray=this.viewer.scene.camera.getPickRay(point);
            return this.viewer.scene.globe.pick(ray,this.viewer.scene);
        }
    }
    addRect(){
        return new Promise((resolve) =>{
            let _self = this;
            let pointsArr = [];
            _self.shape= {
                points:[],
                rect:null,
                entity:null
            };
            var tempPosition;
            var handle = new Cesium.ScreenSpaceEventHandler(_self.viewer.scene.canvas);
            //鼠标左键单击画点
            handle.setInputAction(function(click){
                tempPosition = _self.getPointFromWindowPoint(click.position);
                //选择的点在球面上
                if(tempPosition){
                    if(_self.shape.points.length==0) {
                        pointsArr.push(tempPosition);
                        _self.shape.points.push(_self.viewer.scene.globe.ellipsoid.cartesianToCartographic(tempPosition));
                        _self.shape.rect=Cesium.Rectangle.fromCartographicArray(_self.shape.points);
                        _self.shape.rect.east+=0.000001;
                        _self.shape.rect.north+=0.000001;
                        _self.shape.entity= _self.drawGroup.entities.add({
                            rectangle : {
                                coordinates :_self.shape.rect,
                                material : Cesium.Color.BLUE.withAlpha(0.2),
                                outline : false,
                                outlineWidth: 0,
                                outlineColor : Cesium.Color.BLUE,
                                height:0
                            }
                        });
                        _self.bufferEntity = _self.shape.entity;
                    }
                    else{
                        handle.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                        handle.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                        let drawList = []
                        pointsArr.forEach(element => {
                            let cartographic = Cesium.Cartographic.fromCartesian(element);
                            let lon = Cesium.Math.toDegrees(cartographic.longitude);  // 经度值
                            let lat = Cesium.Math.toDegrees(cartographic.latitude);   // 纬度值
                            drawList.push(lat,lon)
                        });
                        let areaList = [
                            [drawList[0],drawList[1]],
                            [drawList[0],drawList[3]],
                            [drawList[2],drawList[3]],
                            [drawList[2],drawList[1]],
                        ]
                        resolve(areaList)
                    }
                }
            },Cesium.ScreenSpaceEventType.LEFT_CLICK);
            //鼠标移动
            handle.setInputAction(function(movement){
                if(_self.shape.points.length==0){
                    return;
                }
                var moveEndPosition = _self.getPointFromWindowPoint(movement.endPosition);
                //选择的点在球面上
                if(moveEndPosition){
                    pointsArr[1] = moveEndPosition;
                    _self.shape.points[1]=_self.viewer.scene.globe.ellipsoid.cartesianToCartographic(moveEndPosition);
                    _self.shape.rect= Cesium.Rectangle.fromCartographicArray(_self.shape.points);
                    if(_self.shape.rect.west==_self.shape.rect.east)
                        _self.shape.rect.east+=0.000001;
                    if(_self.shape.rect.south==_self.shape.rect.north)
                        _self.shape.rect.north+=0.000001;
                    _self.shape.entity.rectangle.coordinates = _self.shape.rect;
                }
            },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        })
    }
    addPolygon(){
        return new Promise((resolve, reject) =>{
            let that = this
            var polygon_point_arr = [];
            // 临时多边形entity
            var temporary_polygon_entity = null;
            var handler = null;

            // 开启绘制的方法
            function click_draw_polygon() {
                // 清除可能会用到的监听事件
                if (handler) {
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK );
                }
                handler = new Cesium.ScreenSpaceEventHandler(that.viewer.scene.canvas);

                //鼠标左键--确定选中点
                handler.setInputAction((event) => {
                    // 屏幕坐标转为空间坐标
                    let cartesian = that.viewer.camera.pickEllipsoid(event.position, that.viewer.scene.globe.ellipsoid);
                    // 判断是否定义（是否可以获取到空间坐标）
                    if (Cesium.defined(cartesian)) {
                    // 将点添加进保存多边形点的数组中，鼠标停止移动的时添加的点和，点击时候添加的点，坐标一样
                    polygon_point_arr.push(cartesian);
                    // 判断是否开始绘制动态多边形，没有的话则开始绘制
                    if (temporary_polygon_entity == null) {
                        // 绘制动态多边形
                        draw_dynamic_polygon();
                    }
                    }
                }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

                //鼠标移动--实时绘制多边形
                handler.setInputAction((event) => {
                    // 屏幕坐标转为空间坐标
                    let cartesian = that.viewer.camera.pickEllipsoid(event.endPosition, that.viewer.scene.globe.ellipsoid);
                    // 判断是否定义（是否可以获取到空间坐标）
                    if (Cesium.defined(cartesian)) {
                    // 判断是否已经开始绘制动态多边形，已经开始的话，则可以动态拾取鼠标移动的点，修改点的坐标
                    if (temporary_polygon_entity) {
                        // 只要元素点大于一，每次就删除一个点，因为实时动态的点是添加上去的
                        if (polygon_point_arr.length > 1) {
                        // 删除数组最后一个元素（鼠标移动添加进去的点）
                        polygon_point_arr.pop();
                        }
                        // 将新的点添加进动态多边形点的数组中，用于实时变化，注意：这里是先添加了一个点，然后再删除点，再添加，这样重复的
                        polygon_point_arr.push(cartesian);
                    }
                    }
                }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

                //鼠标右键--结束绘制
                handler.setInputAction(() => {
                    // 取消鼠标移动监听
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                    // 清除动态绘制的多边形
                    that.viewer.entities.remove(temporary_polygon_entity);
                    // 删除保存的临时多边形的entity
                    temporary_polygon_entity = null;
                    // 绘制结果多边形
                    draw_polygon();
                    // 清空多边形点数组，用于下次绘制
                    polygon_point_arr = [];
                    // 清除所有事件
                    if (handler) {
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                    handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK );
                    }
                }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK );
            }

            //绘制动态多边形
            function draw_dynamic_polygon() {
            temporary_polygon_entity = that.drawGroup.entities.add({
                polygon: {
                // 这个方法上面有重点说明
                hierarchy: new Cesium.CallbackProperty(() => {
                    // PolygonHierarchy 定义多边形及其孔的线性环的层次结构（空间坐标数组）
                    return new Cesium.PolygonHierarchy(polygon_point_arr);
                }, false),
                extrudedHeight: 0,  // 多边体的高度（多边形拉伸高度）
                height: 10,  // 多边形离地高度
                material: Cesium.Color.BLUE.withAlpha(0.2),
                },
            });
            }

            //绘制结果多边形
            function draw_polygon() {
                // 删除最后一个动态添加的点，如果鼠标没移动，最后一个和倒数第二个是一样的，所以也要删除
                polygon_point_arr.pop();
                // 三个点以上才能绘制成多边形
                if (polygon_point_arr.length >= 3) {
                    that.drawGroup.entities.add({
                    polygon: {
                        hierarchy: polygon_point_arr,
                        extrudedHeight: 0,  // 多边体的高度（多边形拉伸高度）
                        height: 10,  // 多边形离地高度
                        material: Cesium.Color.BLUE.withAlpha(0.2),
                        outlineColor: Cesium.Color.BLUE,
                        outlineWidth: 2
                    },
                    });
                    // 坐标转换--这里可以输出所有点位坐标，不需要就删除了
                    
                    let drawList = []
                    polygon_point_arr.forEach(element => {
                        let cartographic = Cesium.Cartographic.fromCartesian(element);
                        let lon = Cesium.Math.toDegrees(cartographic.longitude);  // 经度值
                        let lat = Cesium.Math.toDegrees(cartographic.latitude);   // 纬度值
                        drawList.push([lat,lon])
                    });
                    drawList.pop()
                    resolve(drawList)
                } else {
                    reject('空')
                }
            }

            click_draw_polygon()
        })
    }
}